import { Button } from '@/components/ui/button';
import { ButtonGroup } from '@/components/ui/button-group';
import type { StatsPeriod } from '@/entities/admin-stats.entity';

const PERIODS: { id: StatsPeriod; label: string }[] = [
	{ id: 'day', label: 'День' },
	{ id: 'week', label: 'Неделя' },
	{ id: 'month', label: 'Месяц' },
	{ id: 'all', label: 'Всё' },
];

interface PeriodFilterProps {
	period: StatsPeriod;
	onChange: (period: StatsPeriod) => void;
}

export default function PeriodFilter({ period, onChange }: PeriodFilterProps) {
	return (
		<ButtonGroup className='w-full'>
			{PERIODS.map(p => (
				<Button
					key={p.id}
					size='sm'
					className='flex-1'
					variant={period === p.id ? 'secondary' : 'outline'}
					onClick={() => onChange(p.id)}
				>
					{p.label}
				</Button>
			))}
		</ButtonGroup>
	);
}
